import React from 'react';
import PropTypes from 'prop-types';
import * as S from './Button.styles';
import Icon from "../Icon/Icon";

const Button = ({
  disabled,
  size,
  variant,
  animated,
  type,
  onClick,
  children,
  id,
  icon,
  iconAlign,
}) => {
  const renderIcon = () => {
    const iconSizes = {
      sm: 20,
      md: 24,
      lg: 28,
      'full-md': 20,
    };

    return (
      <Icon
        cursor={disabled ? 'not-allowed' : 'pointer'}
        variant={variant === 'primary' ? 'neutral' : 'primary'}
        name={icon}
        modifier={variant === 'primary' ? 'inverted' : 'regular'}
        width={iconSizes[size]}
        height={iconSizes[size]}
      />
    );
  };

  return (
    <S.Button
      id={id}
      disabled={disabled}
      size={size}
      variant={variant}
      animated={animated}
      type={type}
      onClick={onClick}
      icon={icon}
      iconAlign={iconAlign}
    >
      {icon && (iconAlign === 'left' || iconAlign === 'center') && renderIcon()}
      {children}
      {icon && iconAlign === 'right' && renderIcon()}
    </S.Button>
  );
};

Button.defaultProps = {
  animated: false,
  disabled: false,
  iconAlign: 'none',
  size: 'lg',
  type: 'button',
  variant: 'primary',
};

Button.propTypes = {
  animated: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  iconAlign: PropTypes.oneOf(['center', 'left', 'right', 'none']),
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'md-full']),
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
};

export default Button;
